import { INotificationPreference, NotificationPreference } from "./NotificationPreference";
import { INotificationSettings } from "./NotificationSettings";
import { INotificationEventSettings, NotificationEventSettings } from "./NotificationEventSettings";
import { AlertRecord } from "../alert";

export enum NotificationTypes {
    card = "card",
    push = "push",
    email = "email",
    sms = "sms",
};

export class Notifications {

    public static shouldUserBeNotified(settings:INotificationEventSettings, level:string = null, category:string = null, type:string = null, site:string = null, device:string = null) {
        if (!settings) {
            settings = {
                "card": {
                    "enabled": true
                }
            };
        }
        let result = new NotificationEventSettings({
            card: settings.card ? settings.card : null,
            push: settings.push ? settings.push : null,
            email: settings.email ? settings.email : null,
            sms: settings.sms ? settings.sms : null
        });

        if (level && settings.byLevel && settings.byLevel[level]) {
            let levelSettings = settings.byLevel[level];
            let levelResult = Notifications.shouldUserBeNotified(levelSettings, level, category, type, site);
            //console.log("levelResult", levelResult);
            for (let key of Object.keys(result)) {
                result[key] = Notifications.overlayPreference(result[key], levelResult[key]);
            }
        }

        if (category && settings.byCategory && settings.byCategory[category]) {
            let categorySettings = settings.byCategory[category];
            let categoryResult = Notifications.shouldUserBeNotified(categorySettings, level, category, type, site);
            //console.log("categoryResult", categoryResult);
            //Object.assign(result, categoryResult);
            for (let key of Object.keys(result)) {
                result[key] = Notifications.overlayPreference(result[key], categoryResult[key]);
            }
        }

        if (type && settings.byType && settings.byType[type]) {
            let typeSettings = settings.byType[type];
            let typeResult = Notifications.shouldUserBeNotified(typeSettings, level, category, type, site);
            //console.log("typeResult", typeResult);
            //Object.assign(result, typeResult);
            for (let key of Object.keys(result)) {
                result[key] = Notifications.overlayPreference(result[key], typeResult[key]);
            }
        }

        if (site && settings.bySite && settings.bySite[site]) {
            let siteSettings = settings.bySite[site];
            let siteResult = Notifications.shouldUserBeNotified(siteSettings, level, category, type, site);
            //console.log("siteResult", siteResult);
            //Object.assign(result, siteResult);
            for (let key of Object.keys(result)) {
                result[key] = Notifications.overlayPreference(result[key], siteResult[key]);
            }
        }

        if (site && settings.byDevice && settings.byDevice[device]) {
            let siteSettings = settings.byDevice[device];
            let siteResult = Notifications.shouldUserBeNotified(siteSettings, level, category, type, site, device);
            //console.log("siteResult", siteResult);
            //Object.assign(result, siteResult);
            for (let key of Object.keys(result)) {
                result[key] = Notifications.overlayPreference(result[key], siteResult[key]);
            }
        }
/*
        for (let key in result) {
            if (result[key] === null)
                delete result[key];
        }

        for (let key in settings) {
            if (settings[key] === null)
                delete settings[key];
        }
        console.log(Object.keys(settings), level, category, type, null, result);*/

        return result;
    }

    public static overlayPreference(basePref:NotificationPreference, overridePref:NotificationPreference):NotificationPreference {
        if (!basePref) {
            return overridePref || null;
        }

        if (!overridePref) {
            return basePref || null;
        }

        let result = new NotificationPreference(basePref);
        if (overridePref.enabled != null) {
            result.enabled = overridePref.enabled;
        }
        if (overridePref.suspended) {
            result.suspended = overridePref.suspended;
        }
        if (overridePref.delay && overridePref.delay > 0) {
            result.delay = overridePref.delay;
        }
        if (overridePref.throttle && overridePref.throttle > 0) {
            result.throttle = overridePref.throttle;
        }
        if (typeof overridePref.sendIfUserOnline !== "undefined" && overridePref.sendIfUserOnline !== null) {
            result.sendIfUserOnline = overridePref.sendIfUserOnline;
        }

        return result;
    }
}
